export const TASK_LIST = 'TASK_LIST';  // 任务列表
export const UNFINISH_TASK_LIST = 'UNFINISH_TASK_LIST';  // 未完成的任务列表
export const TABS_CHANGE = 'TABS_CHANGE';  // tab change
